import {
  Component,
  ElementRef, input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {IoReusableElement} from "@app/layout/components/io-reusable-components/element-models";
import {IoReusableUtils} from "@app/layout/components/io-reusable-components/io-reusable-utils";

@Component({
  selector: 'app-reusable-footer',
  imports: [],
  templateUrl: './reusable-footer.component.html',
  styleUrl: './reusable-footer.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ReusableFooterComponent implements OnChanges {
  @ViewChild('footerRef') footerRef!: ElementRef<HTMLElement>;
  footerData = input<IoReusableElement>();

  ngOnChanges(changes: SimpleChanges): void {
    var data = this.footerData();
    if (!!data) {
      IoReusableUtils.applyTokens(data);
      this.buildFooter(data);
    }
  }

  buildFooter(reusableFeed: IoReusableElement) {
      this.footerRef.nativeElement.className = 'io-footer';
      this.footerRef.nativeElement.replaceChildren();

      const brandCol = IoReusableUtils.createElementFromReusableData('div');
      if (reusableFeed.branding.logo_footer) {
        brandCol.append(IoReusableUtils.createElementFromReusableData('a', {href: reusableFeed.branding.logo_footer.link},
          IoReusableUtils.createElementFromReusableData('img', {src: reusableFeed.branding.logo_footer.url, alt: reusableFeed.branding.logo_footer.alt})));
      }
      if (reusableFeed.footer.contact) {
        brandCol.append(IoReusableUtils.createElementFromReusableData('p', {className: 'io-contact'},
          IoReusableUtils.createElementFromReusableData('a', {href: 'tel:' + reusableFeed.footer.contact.tel, textContent: reusableFeed.footer.contact.text})));
      }
      if (reusableFeed.footer.social_links.length) {
        const social = IoReusableUtils.createElementFromReusableData('div', {className: 'io-social'});
        for (const socialLink of reusableFeed.footer.social_links) {
          social.append(IoReusableUtils.createElementFromReusableData('a', {
            href: socialLink.url,
            target: '_blank',
            rel: 'noopener',
            title: socialLink.service
          }, this.sanitizeSvg(socialLink.icon, socialLink.service.slice(0, 2))));
        }
        brandCol.append(social);
      }

      const navCol = IoReusableUtils.buildMenu(reusableFeed.menus.footer, 'io-footer-nav');

      this.footerRef.nativeElement.append(IoReusableUtils.createElementFromReusableData('div', {className: 'io-footer-top'}, [brandCol, navCol]));

      const copy = IoReusableUtils.createElementFromReusableData('div', {className: 'io-copyright'});
      copy.append(IoReusableUtils.createElementFromReusableData('div', {innerHTML: reusableFeed.footer.copyright}));
      if (reusableFeed.menus.copyright.length) copy.append(IoReusableUtils.buildMenu(reusableFeed.menus.copyright));
      this.footerRef.nativeElement.append(copy);
  }

  private sanitizeSvg(icon: string, placeholder: string): Element{
    try {
      let svgRaw = new DOMParser().parseFromString(decodeURI(icon), 'text/html').body.firstElementChild;
      if (!!svgRaw) {
        let svgElement = svgRaw as SVGSVGElement
        let path = svgElement.firstElementChild;
        if (!!path && path.tagName === 'path' && path.children.length === 0) {
          return svgElement as Element;
        }
      }
    } catch (e) {
      return IoReusableUtils.createElementFromReusableData('span', {textContent: encodeURI(placeholder)});
    }
    return IoReusableUtils.createElementFromReusableData('span', {textContent: encodeURI(placeholder)});
  }
}
